export const POPOVER_LIST_BOX_MAX_HEIGHT = 400;
